import { CustomViewSortOrder } from "../../customView";

export type EmailSearchFilter = {
    // Recherche textuelle générale (sujet, contenu, etc.)
    searchText?: string[];

    // Filtres basés sur les propriétés de base de l'email
    isUnread?: boolean;
    isStarred?: boolean;

    // Filtre par expéditeur
    from?: {
        name?: string;
        email?: string;
    };

    // Filtre par destinataire
    to?: {
        name?: string;
        email?: string;
    };

    // Filtres de date
    dateRange?: {
        start: Date | string;
        end: Date | string;
    };

    // Filtres basés sur les détails AI
    aiCategory?: string;
    aiEntities?: {
        type?: string; // Type d'entité, maintenant optionnel
        content?: string; // Contenu de l'entité, maintenant optionnel
    };

    // Filtres de pièces jointes
    hasAttachments?: boolean;
    attachmentTypes?: string[]; // ex: ['pdf', 'docx']

    // Filtres de labels/dossiers
    labels?: string[];
    folder?: string;

    // Max results
    top?: number;

    // Liste d'IDs de messages à inclure dans la recherche
    internetMessageIds?: string[];

    // Options de tri
    sortBy?: EmailSortBy;
    sortOrder?: CustomViewSortOrder;
};

export enum EmailSortBy {
    DATE = "date",
}

// Exemple d'utilisation:

// {
//   "searchText": ["tache"]
// }

// const searchFilter: EmailSearchFilter = {
//   searchText: "rapport",
//   isUnread: true,
//   aiCategory: "important",
//   aiEntities: {
//     type: "personne",  // Recherche toutes les entités de type "personne"
//     // content: "John Doe"  // On pourrait aussi chercher un contenu spécifique
//   },
//   dateRange: {
//     start: new Date("2024-01-01"),
//     end: new Date("2024-12-31")
//   },
//   sortBy: "date",
//   sortOrder: "desc"
// };
